class PhotoUploader {
  constructor(selector = ".photo-upload") {
    this.elements = Array.from(document.querySelectorAll(selector));
    if (!this.elements.length) return;

    // Добавить класс 'active' на все, кроме первой
    this.elements.forEach((el, index) => {
      if (index !== 0) {
        el.classList.add("active");
      }
    });

    this.elements.forEach((wrapper, index) => {
      const input = wrapper.querySelector(".photo-upload__input");
      const preview = wrapper.querySelector(".photo-upload__preview");
      const image = wrapper.querySelector(".photo-upload__image");
      const placeholder = wrapper.querySelector(".photo-placeholder");
      const button = wrapper.querySelector(".photo-upload__btn");

      if (!input || !preview || !image || !placeholder || !button) return;

      const triggerInput = () => {
        if (wrapper.classList.contains("active") && index !== 0) return;
        input.click();
      };

      preview.addEventListener("click", triggerInput);
      button.addEventListener("click", triggerInput);

      input.addEventListener("change", (e) => {
        const file = e.target.files[0];
        if (file) {
          wrapper.classList.add("loading");

          const reader = new FileReader();
          reader.onload = (event) => {
            image.src = event.target.result;

            image.onload = () => {
              image.style.display = "block";
              placeholder.style.display = "none";

              wrapper.classList.remove("loading");

              const nextWrapper = this.elements[index + 1];
              if (nextWrapper) {
                nextWrapper.classList.remove("active");
              }
            };
          };
          reader.readAsDataURL(file);
        }
      });
    });
  }
}
const labelsContainer = document.querySelector(".labels");

const mainForms = document.querySelectorAll(".main-form.pass");

document.addEventListener("DOMContentLoaded", () => {
  new PhotoUploader();

  if (!labelsContainer) return;

  labelsContainer.addEventListener("click", function (event) {
    const button = event.target.closest("button");
    if (!button) return;

    const labelSpan = button.closest("span");
    if (!labelSpan || !labelsContainer.contains(labelSpan)) return;

    labelSpan.remove();
  });

  const parent = document.querySelector(".company");

if (parent) {
  parent.querySelectorAll('.main-form__area').forEach(textarea => {
    const initialHeight = textarea.offsetHeight;

    textarea.style.height = `${initialHeight}px`;

    textarea.addEventListener('input', () => {
      const text = textarea.value;
      const hasLineBreak = text.includes('\n');
      const isLong = text.length >= 30;

      if (hasLineBreak || isLong) {
        textarea.style.height = 'auto'; 
        textarea.style.height = `${textarea.scrollHeight}px`;
      } else {
        textarea.style.height = `${initialHeight}px`;
      }
    });
  });
}


  mainForms &&
    mainForms.forEach(function (form) {
      const labels = form.querySelectorAll(".main-form__label");

      labels.forEach(function (label) {
        const input = label.querySelector(".main-form__input");
        const btn = label.querySelector(".main-form__icon");

        if (label.classList.contains("mode")) {
          return;
        }

        let mask = label.querySelector(".main-form__mask");
        if (!mask) {
          mask = document.createElement("span");
          mask.className = "main-form__mask";
          label.appendChild(mask);
        }

        if (btn) btn.style.opacity = "0";

        const updateMask = () => {
          mask.textContent = "*".repeat(input.value.length);
        };

        input &&
          input.addEventListener("input", function () {
            if (input.classList.contains("placeholder")) {
              input.classList.remove("placeholder");
              input.placeholder = "";
            }

            if (btn) {
              btn.style.opacity = input.value.length > 0 ? "1" : "0";
            }

            if (!input.classList.contains("show")) {
              updateMask();
            }
          });

        btn &&
          btn.addEventListener("click", function (e) {
            e.preventDefault();

            if (input.classList.contains("placeholder")) return;

            const isShowing = input.classList.toggle("show");
            input.type = isShowing ? "text" : "password";
            btn.classList.toggle("active", isShowing);

            if (!isShowing) {
              updateMask();
            }
          });

        if (input.value) updateMask();
      });
    });
});
